// src/composables/useLecturerReview.js
import { ref } from 'vue'

export function useLecturerReview() {
  // Holds the lecturer's review data
  const lecturerReviews = ref(null)
  // Indicates if the request is in progress
  const loading = ref(false)
  // Holds any error message if the request fails
  const error = ref(null)

  /**
   * Fetch lecturer reviews using the lecturer's ID.
   * The API expects a POST payload with { id: lecturer_id, brand_id: ... }.
   *
   * @param {string} lecturer_id - The unique identifier (hash) of the lecturer.
   */
  async function fetchLecturerReview(lecturer_id) {
    loading.value = true
    error.value = null

    try {
      // Use your brand ID from configuration or a fallback
      const brandId = window.vueAppConfig?.info?.id || 'kVDeWQzE'
      const response = await fetch(
        `${window.vueAppConfig.endpoint}/api/v2/events/review/lecturer`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ id: lecturer_id, brand_id: brandId })
        }
      )

      const data = await response.json()
      if (data.status) {
        lecturerReviews.value = data.data
      } else {
        error.value = data.message || 'Failed to fetch lecturer reviews.'
      }
    } catch (err) {
      error.value = err.message || 'Error fetching lecturer reviews.'
    } finally {
      loading.value = false
    }
  }

  return {
    lecturerReviews,
    loading,
    error,
    fetchLecturerReview
  }
}
